import { buildRoleFromMemberRole, buildCustomerFromDataset, UNKNOWN } from './objectMapping';

export const prepareCustomer = ({ roles, ...customerDataset }) => {
	const aCustomer = buildCustomerFromDataset(customerDataset);

	const decodedRoles = decodeMemberRoles(roles);
	aCustomer.mmNum = getMmNumFromMemberRoles(aCustomer.coNum, decodedRoles);
	aCustomer.roles = prepareRoles(aCustomer.coNum, decodedRoles);
	return aCustomer;
};

export const decodeMemberRoles = (stringRoles = '') => {
	try {
		const decodedRoles = decodeURIComponent(stringRoles.replace(new RegExp('\\\\x', 'g'), '%'));
		return JSON.parse(decodedRoles).memberRoles;
	} catch (e) {
		return [];
	}
};

export const getMmNumFromMemberRoles = (coNum, roles = []) => {
	return parseInt(roles.find(role => parseInt(role.co_num) === coNum)?.mm_num || roles[0]?.mm_num || UNKNOWN);
};

export const prepareRoles = (coNum = UNKNOWN, memberRoles = []) => {
	let companyRoles = {};
	memberRoles
		.filter(role => role.active && (parseInt(role.co_num) === coNum || role.co_num === '0'))
		.forEach(role => {
			if (!Object.prototype.hasOwnProperty.call(companyRoles, role.co_num)) {
				companyRoles[role.co_num] = [];
			}

			companyRoles[role.co_num].push(buildRoleFromMemberRole(role));
		});

	return companyRoles;
};
